// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"284":"2ea70782","361":"94359c83","453":"582855c5","626":"dd6b1f30","651":"0160fc11"}[chunkId] + ".chunk.js";
};